﻿import { contactEntity } from '../model/entity/contact-entity';
import { _clientEntity } from './client-entity-service';


export function getContactEntityById(lastModifiedObject: any) {
    return  contactEntity.query().where('contactId', lastModifiedObject).first();  
}

export function _contactFullName(clientId: number, contactId: number){

    let client = _clientEntity(clientId);
    let contact = contactEntity.query().where('contactId', contactId).first();
    if (contact) {
        if (client && client.clientName) {
            return contact.firstName + " " + contact.lastName + " (" + client.clientName + ")";
        }
        return contact.firstName + " " + contact.lastName;
    }
    return null
    
}

export function _contactEmailAddress(contactId:number):string{
    let contact = contactEntity.query().whereId(contactId).first();
    if(contact){
        return contact.emailAddress;
    }

    return '-';
}
